import React from 'react'
import Style from './index.style'
import AccordionParent from './accordion-parent'

const Accordion = props => {
  return (
    <Style>
      <AccordionParent {...props}></AccordionParent>
    </Style>
  )
}

export default Accordion
